var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

  for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : sParameterName[1];
      }
  }
};

var a_id = getUrlParameter('attachment_id');
var p_t = getUrlParameter('post_type');
var productId = getUrlParameter('productId');

if (a_id) {
  window.location.replace('/pages/the-hangout');
}

if (p_t) {
  if (p_t == 'dealer_portal') {
    window.location.replace('/pages/dealer-portal');
  }
  else if (p_t == 'dealer_portal_social') {
    window.location.replace('/pages/dealer-portal');
  }
  else if (p_t == 'endorsements') {
    window.location.replace('/blogs/the-hangout/tagged/fan-mail');
  }
  else if (p_t == 'freq_asked_questions') {
    window.location.replace('/pages/frequently-asked-questions-faq');
  }
  else if (p_t == 'get_inspired') {
    window.location.replace('/blogs/the-hangout/tagged/fired-up-blog');
  }
  else if (p_t == 'product_ovens') {
    window.location.replace('/collections/all');
  }
  else if (p_t == 'testimonials') {
    window.location.replace('/blogs/the-hangout/tagged/fan-mail');
  }
  else if (p_t == 'videos') {
    window.location.replace('/blogs/the-hangout/tagged/fired-up-blog');
  }
}
